/**
 * Computed-kind FieldTypes.
 *
 * Storage strategy: derived at read time by following a path — not persisted.
 * A lookup's `path` names a link field and a field on the linked record
 * (`organization.founded`); `resolveLookup` in the collections resolves it. Data only: operator groups live in
 * `../operators/computed.ts`.
 */

import type { ComputedFieldType } from "../types.js"

// Computed-kind type names.
export type ComputedType = "lookup"

// COMPUTED (root) — fields derived at read time, not stored. Keyed by the
// `"computed"` literal so the subtype map can spread `fieldTypes.computed` as a
// known property.
export const fieldTypes: Record<"computed", ComputedFieldType> = {
  computed: { name: "computed", kind: "computed", label: "Computed", icon: "wand-magic-sparkles" },
}

// Subtypes — spread the parent entry, override identity.
export const computedTypes: Record<ComputedType, ComputedFieldType> = {
  lookup: {
    ...fieldTypes.computed,
    name: "lookup",
    label: "Lookup",
    parent: "computed",
    icon: "search",
    isEditable: false,
    requiredProps: ["path"],
    format: (value: unknown) => (value == null ? "" : String(value)),
    parse: (input: unknown) => input,
  },
}

Object.assign(fieldTypes, computedTypes)
